import { Form, message } from "antd";
import { FormComponentProps } from "antd/lib/form";
import { ModalSubmitButton } from "components/forms/ModalSubmitButton";
import * as _ from "lodash";
import React, { useCallback } from "react";
import { AdaptionModal } from "../AdaptionModal";
import { Header } from "../ModalHeader";
import { fetchCreateIntention } from "./api";
import { BecomePartnerForm } from "./BecomePartnerForm";
import "./index.scss";

const prefix = "BecomePartnerModal";

interface IProps {
  visible: boolean;
  onClose: () => void;
}

const UnwrappedBecomePartnerModal = (props: IProps & FormComponentProps) => {
  const { visible, onClose, form } = props;

  const handleSubmit = useCallback(() => {
    form.validateFields((err: any, formValue: any) => {
      if (err) {
        message.error("请填写完整的信息");
        return;
      }

      const { ncParams, recommend, other } = formValue;
      const { learnAboutChannel = [] } = formValue;

      const mappedLearnAboutChannel = _.map(learnAboutChannel, key => {
        const obj = {
          type: key,
          extraInfo: null
        } as any;
        if (key === "recommend") {
          obj.extraInfo = recommend;
        }
        if (key === "other") {
          obj.extraInfo = other;
        }
        return obj;
      });

      fetchCreateIntention({
        ...formValue,
        ...ncParams,
        learnAboutChannel: mappedLearnAboutChannel
      }).then(resp => {
        const { success, errorMsg } = resp;
        if (success) {
          message.success("信息已提交！");
        } else {
          message.error(errorMsg);
        }
        onClose();
      });
    });
  }, [form, onClose]);

  return (
    <AdaptionModal
      className={prefix}
      title={null}
      visible={visible}
      closable={false}
      bodyStyle={{ padding: 0 }}
      destroyOnClose={true}
      footer={null}
    >
      <Header title="成为伙伴" onClose={onClose} />
      <BecomePartnerForm form={form} />
      <ModalSubmitButton onClick={handleSubmit} />
    </AdaptionModal>
  );
};

export const BecomePartnerModal = (Form.create()(
  UnwrappedBecomePartnerModal
) as any) as React.ComponentType<IProps>;
